<template>
  <QLayout view="hHh Lpr fFf" class="app-layout-mobile">
    <slot />
    <AppMobileFooter v-if="displayMobileNavigationTabs" />
  </QLayout>
</template>

<script>
import { RouterHelpers } from "@core/helpers";
import { META_MOBILE_NAVIGATION_TABS } from "@etab/config";
import { ScrollManager } from "@core/managers/scroll.manager";
import AppMobileFooter from "./AppMobile.footer.vue";

export default {
  components: {
    AppMobileFooter,
  },
  computed: {
    displayMobileNavigationTabs() {
      return this.$q.screen.xs && RouterHelpers.getRouteMeta(this.$route, META_MOBILE_NAVIGATION_TABS);
    },
  },
  mounted() {
    this.manageScrollHelpers();
  },
  methods: {
    manageScrollHelpers() {
      const layoutContainerOffsetMobile = 100; // height of header offset
      ScrollManager.configureScrollOffset(layoutContainerOffsetMobile);
      // the scroll container is window for mobile
      ScrollManager.configureScrollContainer(window);
    },
  },
};
</script>

<style lang="scss">
.app-layout-mobile {
  background: #f5f5f5;
}
</style>
